import { createInjectionKey as e } from "../../../_utils/vue/create-injection-key.js";
const t = e("n-internal-select-menu"), o = e("n-internal-select-menu-body");
export {
  o as internalSelectionMenuBodyInjectionKey,
  t as internalSelectionMenuInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/select-menu/src/interface.js
// module id = 305
// module chunks = 41